import LabelWithTooltip from "@/components/form/labels/LabelWithTooltip";
import { useWindowSize } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { isDefined, numberOrZero } from "@/utils/utils";
import { Button, Flex } from "antd";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import { QueryKeys } from "../../../../../../common/constants";
import { ClientPremiumType } from "../../../../../client/enums";
import { CLIENT_ROUTE_PATHS } from "../../../../../client/paths";
import { DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH, percentageChange } from "../../../../utils";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatNumber } from "./common/StatNumber";
import { TrendIndicator } from "./common/TrendIndicator";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: {
    clientsCount: number;
    premiumClientsCount?: number;
    previousClientsCount?: number;
  };
};

export const ClientsData = ({ data }: Props) => {
  const { t } = useTranslation();

  const windowSize = useWindowSize();

  const statChange = percentageChange(data.clientsCount, numberOrZero(data.previousClientsCount));

  return (
    <div>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="volcano" icon={<AntIcon type="team" />} />

        <div>
          <span className="margin-left-tiny margin-right-tiny" style={{ fontSize: 21 }}>
            {t("dashboard.statistics.clientsCount")}
          </span>

          <TrendIndicator value={statChange} />
        </div>
      </Flex>

      <Flex justify="center" className="margin-top-medium" style={{ height: STATS_HEIGHT }}>
        <div>
          <Link className="no-link-color-hover" to={CLIENT_ROUTE_PATHS.list.to}>
            <StatNumber value={data.clientsCount} />
          </Link>

          {isDefined(data.premiumClientsCount) ? (
            <>
              <span style={{ fontSize: 26, fontWeight: 100 }}> / </span>
              <LabelWithTooltip
                tooltip={t("dashboard.statisticsExtended.helpers.premiumClients")}
                label={
                  <Link
                    className="no-link-color-hover"
                    to={
                      generatePath(`${CLIENT_ROUTE_PATHS.list.to}`) +
                      URLQuery.searchParamsToString({
                        searchParams: { [QueryKeys.PREMIUM_TYPE]: ClientPremiumType.FULL },
                      })
                    }
                  >
                    <CountUp
                      style={{
                        fontSize: windowSize.innerWidth >= DASHBOARD_LARGER_SCREEN_UPDATE_WIDTH ? 21 : 18,
                        fontWeight: 400,
                      }}
                      duration={4}
                      separator={" "}
                      end={data.premiumClientsCount}
                    />
                  </Link>
                }
              />
            </>
          ) : undefined}
        </div>
      </Flex>
    </div>
  );
};
